export enum UserRole {
   'No Access',
   'View',
   'User',
   'Admin',
}
